<template>
  <v-dialog max-width="550" v-model="dialog.shows.showDetail">
    <v-card>
      <v-card-title>
        <div class="title">{{ $vuetify.lang.t(dialog.title) }}</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-list two-line>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary"
                >mdi-account-card-details-outline</v-icon
              >
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{
                form.fullName
              }}</v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.users.cols.fullname.title2") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-account-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{
                form.username
              }}</v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.users.cols.username.title2") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-cash</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">
                <v-chip
                  :color="form.balance > 0 ? 'teal accent-4' : 'red'"
                  class="chip-list"
                  text-color="white"
                  >{{ form.balance }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.users.cols.balance.title") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-account-alert-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">
                <v-icon
                  :color="form.enabled ? 'teal accent-4' : 'red'"
                  class="pointer"
                  dark
                >
                  <template v-if="form.enabled"
                    >mdi-check-circle-outline</template
                  >
                  <template v-else>mdi-close-circle-outline</template>
                </v-icon>
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.users.cols.enabled.title") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-code-string</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{
                form.code
              }}</v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.users.cols.code.title2") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-phone-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{
                form.phone
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                $vuetify.lang.t("$vuetify.users.cols.phone.title2")
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-at</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">
                {{ form.email }}
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.users.cols.email.title2") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-map-marker-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{
                form.address
              }}</v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.users.cols.address.title2") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-account-group-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">
                <v-chip
                  :color="getRoleColor(form.role)"
                  class="chip-list"
                  text-color="white"
                  v-if="form.role"
                  >{{ $vuetify.lang.t("$vuetify.roles." + form.role) }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.users.cols.role.title2") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-percent-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">
                <v-chip
                  :color="
                    form.paymentChargesPercent > 0 ? 'teal accent-4' : 'red'
                  "
                  class="chip-list"
                  text-color="white"
                  >{{ form.paymentChargesPercent }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle
                >{{
                  $vuetify.lang.t(
                    "$vuetify.users.cols.paymentChargesPercent.title2"
                  )
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-percent-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">
                <v-chip
                  :color="form.withdrawalPercent > 0 ? 'teal accent-4' : 'red'"
                  class="chip-list"
                  text-color="white"
                  >{{ form.withdrawalPercent }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle
                >{{
                  $vuetify.lang.t(
                    "$vuetify.users.cols.withdrawalPercent.title2"
                  )
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{
                form.lastLogin
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                $vuetify.lang.t("$vuetify.users.cols.last_login.title")
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">{{
                form.createdAt
              }}</v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.users.cols.created.title") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-subheader class="body-1 font-weight-bold">{{
            $vuetify.lang.t("$vuetify.users.cols.setting.title")
          }}</v-subheader>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-transfer</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">
                <template
                  v-if="
                    !_.isEmpty(form.settings) &&
                      !_.isEmpty(form.settings['transfer'])
                  "
                >
                  <v-chip
                    :color="
                      form.settings['transfer']['amount_min'] > 0
                        ? 'teal accent-4'
                        : 'red'
                    "
                    class="chip-list"
                    text-color="white"
                    >{{ form.settings["transfer"]["amount_min"] }}
                  </v-chip>
                </template>
                <template v-else> - </template>
              </v-list-item-title>
              <v-list-item-subtitle
                >{{
                  $vuetify.lang.t(
                    "$vuetify.users.cols.setting.transfer.amount_min.title2"
                  )
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-transfer</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">
                <template
                  v-if="
                    !_.isEmpty(form.settings) &&
                      !_.isEmpty(form.settings['transfer'])
                  "
                >
                  <v-chip
                    :color="
                      form.settings['transfer']['amount_max'] > 0
                        ? 'teal accent-4'
                        : 'red'
                    "
                    class="chip-list"
                    text-color="white"
                    >{{ form.settings["transfer"]["amount_max"] }}
                  </v-chip>
                </template>
                <template v-else> - </template>
              </v-list-item-title>
              <v-list-item-subtitle
                >{{
                  $vuetify.lang.t(
                    "$vuetify.users.cols.setting.transfer.amount_max.title"
                  )
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog.shows.showDetail = false" text>{{
          $vuetify.lang.t("$vuetify.btn.close")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Object,
      default: function() {
        return {
          title: "$vuetify.users.view.title",
          shows: {
            showDetail: false
          },
          saveBtnTitle: "$vuetify.btn.save",
          action: "view"
        };
      }
    },
    form: {
      type: Object,
      default: function() {
        return {
          username: null,
          code: null,
          phone: null,
          email: null,
          address: null,
          role: null,
          enabled: null,
          balance: null,
          fullName: null,
          lastLogin: null,
          withdrawalPercent: null,
          paymentChargesPercent: null,
          createdAt: null
        };
      }
    }
  },
  methods: {
    setForm(item) {
      this.form.username = item.username;
      this.form.code = item.code;
      this.form.role = item.role;
      this.form.withdrawalPercent = item.withdrawalPercent;
      this.form.paymentChargesPercent = item.paymentChargesPercent;
      this.form.fullName = item.profile.fullName;
      this.form.phone = item.profile.phone;
      this.form.email = item.profile.email;
      this.form.address = item.profile.address;
      this.form.enabled = item.enabled;
      this.form.balance = item.balance;
      this.form["settings"] = item.settings;
      this.form.createdAt = this.$moment(item.createdAt).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.form.lastLogin = item.lastLogin
        ? this.$moment(item.lastLogin).format("YYYY-MM-DD HH:mm:ss")
        : "-";
    },
    getRoleColor(role) {
      switch (role) {
        case "ROLE_ADMIN":
          return "teal accent-4";
        case "ROLE_COMPTA":
          return "teal accent-3";
        case "ROLE_COMMERCIAL":
          return "secondary";
        default:
          return "orange accent-4";
      }
    }
  }
};
</script>

<style scoped>
>>> .v-list-item__title {
  white-space: initial;
}
</style>
